import React from 'react'
import PropTypes from 'prop-types'
import {
  AlertOutlined,
  ApiOutlined,
  AppstoreOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  AuditOutlined,
  BarsOutlined,
  CalendarOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
  CheckOutlined,
  CheckCircleFilled,
  CheckCircleOutlined,
  CloseOutlined,
  CompassOutlined,
  DashboardOutlined,
  DownloadOutlined,
  EnvironmentOutlined,
  ExclamationCircleOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  GiftOutlined,
  GatewayOutlined,
  GlobalOutlined,
  LineChartOutlined,
  LinkOutlined,
  LogoutOutlined,
  MailOutlined,
  MessageOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PhoneOutlined,
  PoweroffOutlined,
  PrinterOutlined,
  QrcodeOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  SlidersOutlined,
  SolutionOutlined,
  StopOutlined,
  SwapRightOutlined,
  SyncOutlined,
  TagOutlined,
  TeamOutlined,
  UserOutlined,
  WarningOutlined,
} from '@ant-design/icons'

const ICON_BY_TYPE = {
  alert: AlertOutlined,
  api: ApiOutlined,
  appstore: AppstoreOutlined,
  'arrow-left': ArrowLeftOutlined,
  'arrow-right': ArrowRightOutlined,
  audit: AuditOutlined,
  bars: BarsOutlined,
  block: StopOutlined,
  calendar: CalendarOutlined,
  'caret-down': CaretDownOutlined,
  'caret-up': CaretUpOutlined,
  check: CheckOutlined,
  'check-circle': CheckCircleFilled,
  'check-circle-o': CheckCircleOutlined,
  close: CloseOutlined,
  compass: CompassOutlined,
  dashboard: DashboardOutlined,
  down: CaretDownOutlined,
  download: DownloadOutlined,
  'environment-o': EnvironmentOutlined,
  exception: FileProtectOutlined,
  'exclamation-circle-o': ExclamationCircleOutlined,
  'file-text': FileTextOutlined,
  gateway: GatewayOutlined,
  gift: GiftOutlined,
  global: GlobalOutlined,
  left: ArrowLeftOutlined,
  'line-chart': LineChartOutlined,
  link: LinkOutlined,
  logout: LogoutOutlined,
  mail: MailOutlined,
  message: MessageOutlined,
  'menu-fold': MenuFoldOutlined,
  'menu-unfold': MenuUnfoldOutlined,
  phone: PhoneOutlined,
  poweroff: PoweroffOutlined,
  printer: PrinterOutlined,
  qrcode: QrcodeOutlined,
  'question-circle-o': QuestionCircleOutlined,
  right: ArrowRightOutlined,
  setting: SettingOutlined,
  sliders: SlidersOutlined,
  solution: SolutionOutlined,
  'swap-right': SwapRightOutlined,
  sync: SyncOutlined,
  'tag-o': TagOutlined,
  team: TeamOutlined,
  user: UserOutlined,
  warning: WarningOutlined,
}

const Icon = ({ type, ...props }) => {
  const AntdIcon = ICON_BY_TYPE[type] || QuestionCircleOutlined
  return <AntdIcon {...props} />
}

Icon.propTypes = {
  type: PropTypes.string.isRequired,
}

export default Icon
